import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import CandidateService from './CandidateService';

const AddCandidatesModal = ({ show, onHide, roleIdentifier, onCandidatesAdded }) => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [availableCandidates, setAvailableCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      loadAvailableCandidates();
    }
  }, [show]);

  const loadAvailableCandidates = async () => {
    try {
      setLoading(true);
      const candidates = await CandidateService.getAvailableCandidates();
      setAvailableCandidates(candidates);
    } catch (error) {
      console.error('Error loading candidates:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (selectedCandidates.length === 0) {
      alert('Please select at least one candidate');
      return;
    }

    try {
      setSubmitting(true);
      const candidateIds = selectedCandidates.map(c => c.value);
      const response = await CandidateService.addCandidatesToRole(roleIdentifier, candidateIds);
      
      console.log('Candidates added:', response);
      
      // Call the callback with the newly added candidates
      if (onCandidatesAdded) {
        const newCandidates = selectedCandidates.map(c => ({
          id: c.value,
          text: c.label
        }));
        onCandidatesAdded(newCandidates);
      }
      
      // Reset and close
      setSelectedCandidates([]);
      onHide();
    } catch (error) {
      console.error('Error adding candidates:', error);
      alert('Error adding candidates. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSelectedCandidates([]);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Candidates to Position</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Select Candidates</Form.Label>
          {loading ? (
            <p className="text-muted">Loading candidates...</p>
          ) : (
            <Select
              isMulti
              value={selectedCandidates}
              onChange={setSelectedCandidates}
              options={availableCandidates}
              placeholder="Select one or more candidates..."
              className="react-select-container"
              classNamePrefix="react-select"
              isDisabled={submitting}
            />
          )}
          <Form.Text className="text-muted">
            Select candidates to add them to the "Submitting Application" stage
          </Form.Text>
        </Form.Group>
        {selectedCandidates.length > 0 && (
          <div className="alert alert-info">
            <strong>{selectedCandidates.length}</strong> candidate
            {selectedCandidates.length !== 1 ? 's' : ''} selected
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSubmit} 
          disabled={submitting || selectedCandidates.length === 0}
        >
          {submitting ? 'Adding...' : 'Add Candidates'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCandidatesModal;
